export default __webpack_public_path__ + "assets/037088c9ca591d1206558d86b5cfcbe3.jpeg";